import gql from 'graphql-tag'
export const fetchEmptyFreeBeerQuery = gql`
  query ($cart_id: String!) {
    emptyFreeBeerArray (
      cart_id: $cart_id
    ) {
      message
    }
  }
`
